import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=2a31412b&scoped=true"
import script from "./NumberField.vue?vue&type=script&lang=js"
export * from "./NumberField.vue?vue&type=script&lang=js"
import style0 from "./NumberField.vue?vue&type=style&index=0&id=2a31412b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31412b",
  null
  
)

export default component.exports